// extracted by mini-css-extract-plugin
export var searchHeader = "_o-0";
export var searchHeaderDark = "_o-1";